module.exports = __webpack_public_path__ + "HelveticaNeueLTStdBd.f5f2602349162805ee06.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/HelveticaNeueLTStdBd.svg
// module id = ../../../../../src/assets/fonts/HelveticaNeueLTStdBd.svg
// module chunks = styles